// extracted by mini-css-extract-plugin
module.exports = {"EcosystemC":"EcosystemC_EcosystemC__oZJPJ"};